/** @format */

import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
	name: 'boldSpan',
	standalone: true
})
export class BoldSpanPipe implements PipeTransform {
	transform(value: string, regex: string): string {
		return this.replace(value, regex);
	}

	private replace(str: string | null | undefined, regex: string): string {
		return str?.replace(new RegExp(`\\b${regex}\\b`, 'gi'), '<b>$&</b>') ?? '';
	}
}
